
// import React, { useEffect, useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import A1 from '../Login/Chatbot.jpeg';

// const Sidebar = () => {
//   const [permissions, setPermissions] = useState([]);
//   const [openMenu, setOpenMenu] = useState(null);
//   const [userName, setUserName] = useState('User Name');
//   const [userImage, setUserImage] = useState(null);
//   const [userRole, setUserRole] = useState(null);
//   const [showAppointment, setShowAppointment] = useState(false);
//   const [showTemplates, setShowTemplates] = useState(true);

//   const navigate = useNavigate();

//   useEffect(() => {
//     const stored = sessionStorage.getItem("user");
//     if (stored) {
//       const u = JSON.parse(stored);
//       setUserName(u.name || "User");
//       setUserImage(u.image || null);
//       setUserRole(u.role || null);

//       if (u.role === "member") {
//         try {
//           const perms = typeof u.permissions === "string" ? JSON.parse(u.permissions) : u.permissions;
//           setPermissions(perms.map(p => p.toLowerCase())); // convert to lowercase for easy matching
//         } catch (err) {
//           console.error("Invalid permissions format", err);
//           setPermissions([]);
//         }
//       }

//       if (u.email === "vckumar555@gmail.com") {
//         setShowAppointment(true);
//       }
//     }
//   }, []);

//   const menuItems = [
//     { path: '/dashboard', icon: 'fa-tachometer-alt', label: 'Dashboard' },
//     {
//       path: '/message-templates',
//       icon: 'fa-envelope',
//       label: 'Message Templates',
//       children: [
//         ...(showTemplates ? [{ path: '/message-templates', label: 'Templates' }] : []),
//         ...(showAppointment ? [
//           { path: '/appointment', label: 'PP Appointment' },
//           { path: '/message-templates/us-visa-appointment', label: 'US Visa Appointment' },
//           { path: '/message-templates/labour-license', label: 'Labour License' },
//           { path: '/message-templates/trade-license', label: 'Trade License' },
//           { path: '/message-templates/birthday-greetings', label: 'Birthday Greetings' },
//           { path: '/message-templates/festival-greetings', label: 'Festival Greetings' },
//         ] : []),
//       ]
//     },
//     {
//       path: '/singlecontacts', icon: 'fa-address-book', label: 'Contacts',
//       children: [
//         { path: '/singlecontacts', label: 'Single contact' },
//         { path: '/Add-new', label: 'Group contact' },
//       ]
//     },
//     {
//       path: '/', icon: 'fa-table', label: 'Table Config',
//       children: [
//         { path: '/table-create', label: 'Table create' },
//         { path: '/usertables-list', label: 'User tables list' },
//       ]
//     },
//     {
//       path: '/', icon: 'fa-clipboard', label: 'Bot Config',
//       children: [
//         { path: '/template-Form', label: 'Template Mapping' },
//         { path: '/template-list', label: 'Template Mapping List' },
//       ]
//     },
//     {
//       path: '/', icon: 'fa-list', label: 'Column Mapping',
//       children: [
//         { path: '/column-mapping', label: 'Column Mapping' },
//         { path: '/language', label: 'Language' },
//       ]
//     },
//     {
//        path: '/', icon: 'fa-list', label: 'UserCreation',
//         children: [
//           {path: '/userCreate', label: 'Create a User'},
//         ]
//     },
//     {
//       path:'/', icon: 'fa-list', label: 'Groups',
//       children:[
//         {path:'/createGroup', label:'CreateGroup'},
//         {path:'/groupMessage', label:'Group Message'},
//         {path:'/groupsInvite', label:'Group Invite'},
//         {path:'/getGroups', label:'GroupInfo'},

//       ]

//     }
//   ];

//   const toggleSubMenu = (index) => {
//     setOpenMenu(openMenu === index ? null : index);
//   };


// const sessionUser = JSON.parse(sessionStorage.getItem("user"));
// const loggedInUserId = sessionUser?.id;
// console.log('this sis id',loggedInUserId)
// const loggedInEmail = sessionUser?.email;

// // STEP 1 → APPLY NORMAL PERMISSION FILTERING
// let filteredMenuItems =
//   userRole === "admin"
//     ? menuItems
//     : menuItems
//         .map(item => {
//           // Always show Dashboard
//           if (item.label === "Dashboard") return item;

//           // Always show Templates
//           if (item.label === "Message Templates") {
//             return {
//               ...item,
//               children: item.children  // do not filter children
//             };
//           }

//           // Filter based on permissions
//           const children = item.children?.filter(child =>
//             permissions.includes(child.label.toLowerCase())
//           );

//           if (children?.length > 0 || permissions.includes(item.label.toLowerCase())) {
//             return { ...item, children };
//           }

//           return null;
//         })
//         .filter(Boolean);

// // STEP 2 → CONTROL UserCreation SEPARATELY
// filteredMenuItems = filteredMenuItems.filter(item => {
//   if (item.label === "UserCreation"|| item.label === "Groups") {
//     return (
//       loggedInUserId === 19 ||
//       loggedInEmail === "emedhatechnologies@gmail.com"
//     );
//   }
//   return true;
// });

// return (
//     <div style={{ width: '250px', height: '100vh', backgroundColor: '#075E54', color: 'white', display: 'flex', flexDirection: 'column', padding: '20px', fontSize: "12px" }}>
//       <div style={{ display: 'flex', alignItems: 'center', marginBottom: '30px' }}>
//         <img src={A1} alt="Logo" className="me-2" style={{ width: '90px', borderRadius: '50%' }} />
//         <span style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>eMedha Chatbot Services</span>
//       </div>

//       <div style={{ display: 'flex', alignItems: 'center', padding: '10px', marginBottom: '20px', cursor: 'pointer', borderRadius: '5px' }} onClick={() => navigate('/profile')}>
//         {userImage ? (
//           <img src={userImage} alt="Profile" style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }} />
//         ) : (
//           <i className="fas fa-user-circle fa-2x"></i>
//         )}
//         <span style={{ fontSize: '1rem', fontWeight: 'bold', marginLeft: '10px' }}>{userName}</span>
//       </div>

//       <nav>
//         <ul className="list-unstyled">
//           {filteredMenuItems.map((item, index) => (
//             <li key={index} className="mb-2">
//               <div
//                 style={{ display: 'flex', alignItems: 'center', padding: '10px', color: 'white', textDecoration: 'none', borderRadius: '5px', cursor: 'pointer' }}
//                 onClick={() => { item.children ? toggleSubMenu(index) : navigate(item.path); }}
//                 className="d-flex align-items-center justify-content-between"
//               >
//                 <div><i className={`fas ${item.icon} me-2`}></i>{item.label}</div>
//                 {item.children && (<i className={`fas fa-chevron-${openMenu === index ? 'up' : 'down'}`}></i>)}
//               </div>
//               {item.children && openMenu === index && (
//                 <ul style={{ paddingLeft: '20px', display: 'flex', flexDirection: 'column' }} className="list-unstyled">
//                   {item.children.map((child, childIndex) => (
//                     <li key={childIndex}>
//                       <Link to={child.path} className="d-block text-white py-1 ps-3" style={{ textDecoration: 'none' }}>- {child.label}</Link>
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </li>
//           ))}
//         </ul>
//       </nav>
//     </div>
//   );
// };

// export default Sidebar;

// import { useState, useRef, useEffect } from "react";
// import {
//   LayoutDashboard, MessageSquare, Users, Table2, Bot,
//   Columns, UserPlus, UsersRound, ChevronDown, ChevronRight, LogOut, X,
//   UserCircle, Phone, Bug, ChevronUp,
// } from "lucide-react";

// // Assuming these paths are configured or adjust as per your project setup
// // For the logo image, standard HTML <img> is used below to avoid Next.js Image component dependency in pure React.
// import logoImg from '../Login/Chatbot.jpeg';

// const NAV_ITEMS = [
//   { label: "Dashboard", icon: <LayoutDashboard size={17} /> },
//   { label: "Message Templates", icon: <MessageSquare size={17} />, children: ["Templates"] },
//   { label: "Contacts", icon: <Users size={17} />, children: ["Single Contact", "Group Contact"] },
//   { label: "Table Config", icon: <Table2 size={17} />, children: ["Create Table", "User Tables List"] },
//   { label: "Bot Config", icon: <Bot size={17} />, children: ["Template Mapping", "Template Mapping List"] },
//   { label: "Column Mapping", icon: <Columns size={17} />, children: ["Column Mapping", "Language"] },
//   { label: "UserCreation", icon: <UserPlus size={17} />, children: ["Create a User"] },
//   { label: "Groups", icon: <UsersRound size={17} />, children: ["Create Group", "Group Message", "Group Invite"] },
// ];

// export default function Sidebar({
//   activeNav,
//   setActiveNav,
//   onClose,
//   mobile = false,
// }) {
//   const [profileOpen, setProfileOpen] = useState(false);
//   const profileRef = useRef(null);

//   // States to handle hover styling natively via JavaScript inline styles
//   const [hoveredClose, setHoveredClose] = useState(false);
//   const [hoveredItem, setHoveredItem] = useState(null);
//   const [hoveredChild, setHoveredChild] = useState(null);
//   const [hoveredProfile, setHoveredProfile] = useState(false);
//   const [hoveredDropdownItem, setHoveredDropdownItem] = useState(null);

//   useEffect(() => {
//     function handleClick(e) {
//       if (profileRef.current && !profileRef.current.contains(e.target)) {
//         setProfileOpen(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClick);
//     return () => document.removeEventListener("mousedown", handleClick);
//   }, []);

//   const [openMenus, setOpenMenus] = useState(
//     NAV_ITEMS.filter((i) => i.children).map((i) => i.label)
//   );

//   const toggleMenu = (label) => {
//     setOpenMenus((prev) =>
//       prev.includes(label) ? prev.filter((l) => l !== label) : [...prev, label]
//     );
//   };

//   return (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         height: "100%",
//         backgroundColor: "var(--card, #ffffff)",
//         borderRight: "1px solid var(--border, #e5e7eb)",
//         width: "260px",
//         boxSizing: "border-box",
//       }}
//     >
//       {/* Logo Section */}
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           padding: "16px 20px",
//           borderBottom: "1px solid var(--border, #e5e7eb)",
//         }}
//       >
//         <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//           <img
//             src={logoImg}
//             alt="eMedha Chatbot Services logo"
//             style={{ width: "40px", height: "40px", objectFit: "contain" }}
//             onError={(e) => {
//               // Simple image fallback mechanism if it fails to load
//               e.target.style.display = 'none'; 
//             }}
//           />
//           <div>
//             <p
//               style={{
//                 fontFamily: "'Plus Jakarta Sans', sans-serif",
//                 fontSize: "14px",
//                 fontWeight: "bold",
//                 color: "var(--foreground, #111827)",
//                 lineHeight: 1,
//                 margin: 0,
//               }}
//             >
//               eMedha
//             </p>
//             <p
//               style={{
//                 fontSize: "10px",
//                 color: "var(--muted-foreground, #6b7280)",
//                 marginTop: "2px",
//                 lineHeight: 1,
//                 margin: 0,
//               }}
//             >
//               Chatbot Services
//             </p>
//           </div>
//         </div>
//         {mobile && onClose && (
//           <button
//             onClick={onClose}
//             onMouseEnter={() => setHoveredClose(true)}
//             onMouseLeave={() => setHoveredClose(false)}
//             style={{
//               background: "none",
//               border: "none",
//               cursor: "pointer",
//               padding: 0,
//               color: hoveredClose ? "var(--foreground, #3d78f8)" : "var(--muted-foreground, #6b7280)",
//               transition: "color 0.2s ease",
//               display: "flex",
//               alignItems: "center",
//             }}
//           >
//             <X size={18} />
//           </button>
//         )}
//       </div>

//       {/* Navigation Links */}
//       <nav
//         style={{
//           flex: 1,
//           overflowY: "auto",
//           padding: "12px",
//           display: "flex",
//           flexDirection: "column",
//           gap: "2px",
//         }}
//       >
//         {NAV_ITEMS.map((item) => {
//           const isOpen = openMenus.includes(item.label);
//           const isActive = activeNav === item.label || (item.children?.includes(activeNav) ?? false);
//           const isItemHovered = hoveredItem === item.label;

//           let itemBg = "transparent";
//           let itemColor = "var(--muted-foreground, #6b7280)";

//           if (isActive && !item.children) {
//             itemBg = "var(--secondary, #f3f4f6)";
//             itemColor = "var(--primary, #3b82f6)";
//           } else if (isItemHovered) {
//             itemBg = "var(--muted, #f3f4f6)";
//             itemColor = "var(--foreground, #111827)";
//           }

//           return (
//             <div key={item.label} style={{ width: "100%" }}>
//               <button
//                 onClick={() => {
//                   if (item.children) {
//                     toggleMenu(item.label);
//                   } else {
//                     setActiveNav(item.label);
//                     onClose?.();
//                   }
//                 }}
//                 onMouseEnter={() => setHoveredItem(item.label)}
//                 onMouseLeave={() => setHoveredItem(null)}
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   padding: "10px 12px",
//                   borderRadius: "8px",
//                   fontSize: "14px",
//                   fontWeight: 500,
//                   border: "none",
//                   cursor: "pointer",
//                   textAlign: "left",
//                   transition: "all 0.2s ease",
//                   backgroundColor: itemBg,
//                   color: itemColor,
//                 }}
//               >
//                 <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                   <span
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       color: isActive && !item.children ? "var(--primary, #3b82f6)" : (isItemHovered ? "var(--foreground, #111827)" : "var(--muted-foreground, #6b7280)"),
//                     }}
//                   >
//                     {item.icon}
//                   </span>
//                   {item.label}
//                 </span>
//                 {item.children && (
//                   <span style={{ color: "var(--muted-foreground, #6b7280)", display: "flex", alignItems: "center" }}>
//                     {isOpen ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
//                   </span>
//                 )}
//               </button>

//               {/* Sub-menu Dropdowns */}
//               {item.children && isOpen && (
//                 <div
//                   style={{
//                     marginLeft: "28px",
//                     marginTop: "2px",
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "2px",
//                   }}
//                 >
//                   {item.children.map((child) => {
//                     const isChildActive = activeNav === child;
//                     const isChildHovered = hoveredChild === child;

//                     let childBg = "transparent";
//                     let childColor = "var(--muted-foreground, #6b7280)";

//                     if (isChildActive) {
//                       childBg = "var(--secondary, #f3f4f6)";
//                       childColor = "var(--primary, #3b82f6)";
//                     } else if (isChildHovered) {
//                       childBg = "var(--muted, #f3f4f6)";
//                       childColor = "var(--foreground, #111827)";
//                     }

//                     return (
//                       <button
//                         key={child}
//                         onClick={() => {
//                           setActiveNav(child);
//                           onClose?.();
//                         }}
//                         onMouseEnter={() => setHoveredChild(child)}
//                         onMouseLeave={() => setHoveredChild(null)}
//                         style={{
//                           width: "100%",
//                           textAlign: "left",
//                           padding: "8px 12px",
//                           borderRadius: "8px",
//                           fontSize: "12px",
//                           fontWeight: 500,
//                           border: "none",
//                           cursor: "pointer",
//                           transition: "all 0.2s ease",
//                           backgroundColor: childBg,
//                           color: childColor,
//                         }}
//                       >
//                         {child}
//                       </button>
//                     );
//                   })}
//                 </div>
//               )}
//             </div>
//           );
//         })}
//       </nav>

//       {/* User Dropdown / Profile Section */}
//       <div
//         ref={profileRef}
//         style={{
//           padding: "16px 12px",
//           borderTop: "1px solid var(--border, #e5e7eb)",
//           position: "relative",
//         }}
//       >
//         {/* Upper Profile Dropdown overlay menu */}
//         {profileOpen && (
//           <div
//             style={{
//               position: "absolute",
//               bottom: "100%",
//               left: "12px",
//               right: "12px",
//               marginBottom: "8px",
//               backgroundColor: "var(--card, #ffffff)",
//               borderRadius: "12px",
//               border: "1px solid var(--border, #e5e7eb)",
//               boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
//               overflow: "hidden",
//               zIndex: 10,
//             }}
//           >
//             {[
//               { icon: <UserCircle size={15} />, label: "My Account" },
//               { icon: <Phone size={15} />, label: "WhatsApp Numbers" },
//               { icon: <Bug size={15} />, label: "Report Bug" },
//             ].map(({ icon, label }) => (
//               <button
//                 key={label}
//                 onMouseEnter={() => setHoveredDropdownItem(label)}
//                 onMouseLeave={() => setHoveredDropdownItem(null)}
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   padding: "10px 16px",
//                   fontSize: "12px",
//                   fontWeight: 500,
//                   border: "none",
//                   textAlign: "left",
//                   cursor: "pointer",
//                   color: "var(--foreground, #111827)",
//                   backgroundColor: hoveredDropdownItem === label ? "var(--muted, #f3f4f6)" : "transparent",
//                   transition: "background-color 0.2s ease",
//                 }}
//               >
//                 <span style={{ color: "var(--muted-foreground, #6b7280)", display: "flex", alignItems: "center" }}>
//                   {icon}
//                 </span>
//                 {label}
//               </button>
//             ))}
//             <div style={{ height: "1px", backgroundColor: "var(--border, #e5e7eb)", margin: "0 12px" }} />
//             <button
//               onMouseEnter={() => setHoveredDropdownItem("logout")}
//               onMouseLeave={() => setHoveredDropdownItem(null)}
//               style={{
//                 width: "100%",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "10px",
//                 padding: "10px 16px",
//                 fontSize: "12px",
//                 fontWeight: 500,
//                 border: "none",
//                 textAlign: "left",
//                 cursor: "pointer",
//                 color: "#ef4444",
//                 backgroundColor: hoveredDropdownItem === "logout" ? "#fef2f2" : "transparent",
//                 transition: "background-color 0.2s ease",
//               }}
//             >
//               <LogOut size={15} />
//               Log Out
//             </button>
//           </div>
//         )}

//         {/* Profile Trigger Button */}
//         <button
//           onClick={() => setProfileOpen((v) => !v)}
//           onMouseEnter={() => setHoveredProfile(true)}
//           onMouseLeave={() => setHoveredProfile(false)}
//           style={{
//             width: "100%",
//             display: "flex",
//             alignItems: "center",
//             gap: "12px",
//             padding: "10px 12px",
//             borderRadius: "8px",
//             border: "none",
//             cursor: "pointer",
//             backgroundColor: hoveredProfile ? "var(--muted, #f3f4f6)" : "transparent",
//             transition: "background-color 0.2s ease",
//           }}
//         >
//           <div
//             style={{
//               width: "32px",
//               height: "32px",
//               borderRadius: "50%",
//               backgroundColor: "rgba(59, 130, 246, 0.1)", 
//               color: "var(--primary, #3b82f6)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               fontSize: "12px",
//               fontWeight: "bold",
//               flexShrink: 0,
//             }}
//           >
//             EM
//           </div>
//           <div style={{ flex: 1, minWidth: 0, textAlign: "left" }}>
//             <p
//               style={{
//                 fontSize: "12px",
//                 fontWeight: 600,
//                 color: "var(--foreground, #111827)",
//                 margin: 0,
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//                 whiteSpace: "nowrap",
//               }}
//             >
//               Admin User
//             </p>
//             <p
//               style={{
//                 fontSize: "10px",
//                 color: "var(--muted-foreground, #6b7280)",
//                 margin: 0,
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//                 whiteSpace: "nowrap",
//               }}
//             >
//               admin@emedha.com
//             </p>
//           </div>
//           {profileOpen ? (
//             <ChevronUp size={14} style={{ color: "var(--muted-foreground, #6b7280)", flexShrink: 0 }} />
//           ) : (
//             <ChevronDown size={14} style={{ color: "var(--muted-foreground, #6b7280)", flexShrink: 0 }} />
//           )}
//         </button>
//       </div>
//     </div>
//   );
// }


// import React, { useEffect, useState, useRef } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import A1 from '../Login/Chatbot.jpeg';

// const Sidebar = () => {
//   // --- KEEPING EXACT FUNCTIONALITIES AND STATES ---
//   const [permissions, setPermissions] = useState([]);
//   const [openMenu, setOpenMenu] = useState(null);
//   const [userName, setUserName] = useState('User Name');
//   const [userImage, setUserImage] = useState(null);
//   const [userRole, setUserRole] = useState(null);
//   const [showAppointment, setShowAppointment] = useState(false);
//   const [showTemplates, setShowTemplates] = useState(true);

//   const navigate = useNavigate();

//   // --- NEW UI STATES FOR HOVER & POPUP ---
//   const [profileOpen, setProfileOpen] = useState(false);
//   const [isMobileOpen, setIsMobileOpen] = useState(false);
//   const [hoveredItem, setHoveredItem] = useState(null);
//   const [hoveredChild, setHoveredChild] = useState(null);
//   const [hoveredProfile, setHoveredProfile] = useState(false);
//   const [hoveredDropdownItem, setHoveredDropdownItem] = useState(null);

//   const profileRef = useRef(null);

//   useEffect(() => {
//     const stored = sessionStorage.getItem("user");
//     if (stored) {
//       const u = JSON.parse(stored);
//       setUserName(u.name || "User");
//       setUserImage(u.image || null);
//       setUserRole(u.role || null);

//       if (u.role === "member || admin")     {
//         try {
//           const perms = typeof u.permissions === "string" ? JSON.parse(u.permissions) : u.permissions;
//           setPermissions(perms.map(p => p.toLowerCase()));
//         } catch (err) {
//           console.error("Invalid permissions format", err);
//           setPermissions([]);
//         }
//       }

//       if (u.email === "vckumar555@gmail.com") {
//         setShowAppointment(true);
//       }
//     }

//     // Dropdown close listener
//     function handleClick(e) {
//       if (profileRef.current && !profileRef.current.contains(e.target)) {
//         setProfileOpen(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClick);
//     return () => document.removeEventListener("mousedown", handleClick);
//   }, []);

//   const sessionUser = JSON.parse(sessionStorage.getItem("user"));
//   const loggedInUserId = sessionUser?.id;
//   const loggedInEmail = sessionUser?.email;

//   const isSuperAdmin =
//     loggedInEmail === "emedhatechnologies@gmail.com";

//   const menuItems = [
//     { path: '/dashboard', icon: 'fa-tachometer-alt', label: 'Dashboard' },
//     {
//       path: '/singlecontacts', icon: 'fa-address-book', label: 'Manage Contacts',
//       children: [
//         { path: '/add-group', label: 'Add Groups' },
//         { path: '/singlecontacts', label: 'Add contact' },
//         { path: '/Add-new', label: 'Contact List' },
//       ]
//     },
//     { path: '/message_analytics/SendMessage', icon: 'fa-arrow-right', label: 'Send Message' },
//     {
//       path: '/message-templates',
//       icon: 'fa-envelope',
//       label: 'Message Templates',
//       children: [
//         ...(showTemplates ? [{ path: '/message-templates', label: 'Templates' }] : []),
//         ...(showAppointment ? [
//           { path: '/appointment', label: 'PP Appointment' },
//           { path: '/message-templates/us-visa-appointment', label: 'US Visa Appointment' },
//           { path: '/message-templates/labour-license', label: 'Labour License' },
//           { path: '/message-templates/trade-license', label: 'Trade License' },
//           { path: '/message-templates/birthday-greetings', label: 'Birthday Greetings' },
//           { path: '/message-templates/festival-greetings', label: 'Festival Greetings' },
//         ] : []),
//       ]
//     },
//     { path: '/message_analytics', icon: 'fa-envelope', label: 'Message Analytics' },



//     // ...(isSuperAdmin
//     //   ? [
//         {
//           path: '/', icon: 'fa-table', label: 'Table Config',
//           children: [
//             { path: '/table-create', label: 'Table create' },
//             { path: '/usertables-list', label: 'User tables list' },
//           ]
//         },
//         {
//           path: '/', icon: 'fa-clipboard', label: 'Bot Config',
//           children: [
//             { path: '/template-Form', label: 'Template Mapping' },
//             { path: '/template-list', label: 'Template Mapping List' },
//           ]
//         },
//         {
//           path: '/', icon: 'fa-list', label: 'Column Mapping',
//           children: [
//             { path: '/column-mapping', label: 'Column Mapping' },
//             { path: '/language', label: 'Language' },
//           ]
//         },
//         {
//           path: '/', icon: 'fa-user-plus', label: 'UserCreation',
//           children: [
//             { path: '/userCreate', label: 'Create a User' },
//             { path: '/UserManagement', label: 'User Management' },
//           ]
//         },
//         {
//           path: '/', icon: 'fa-users', label: 'Groups',
//           children: [
//             { path: '/createGroup', label: 'CreateGroup' },
//             { path: '/groupMessage', label: 'Group Message' },
//             { path: '/groupsInvite', label: 'Group Invite' },
//             { path: '/getGroups', label: 'GroupInfo' },
//           ]
//         }
//       // ]
//       // : [])
//   ];

//   const toggleSubMenu = (index) => {
//     setOpenMenu(openMenu === index ? null : index);
//   };

//   // const sessionUser = JSON.parse(sessionStorage.getItem("user"));
//   // const loggedInUserId = sessionUser?.id;
//   // const loggedInEmail = sessionUser?.email;

//   // --- KEEPING EXACT ORIGINAL CONDITIONAL FILTERS ---
//   let filteredMenuItems =
//     userRole === "admin"
//       ? menuItems
//       : menuItems
//         .map(item => {
//           if (item.label === "Dashboard") return item;
//           if (item.label === "Message Templates") {
//             return { ...item, children: item.children };
//           }
//           const children = item.children?.filter(child =>
//             permissions.includes(child.label.toLowerCase())
//           );
//           if (children?.length > 0 || permissions.includes(item.label.toLowerCase())) {
//             return { ...item, children };
//           }
//           return null;
//         })
//         .filter(Boolean);

//   filteredMenuItems = filteredMenuItems.filter(item => {
//     if (item.label === "UserCreation" || item.label === "Groups") {
//       return (
//         loggedInUserId === 19 ||
//         loggedInEmail === "emedhatechnologies@gmail.com"
//       );
//     }
//     return true;
//   });

//   // --- HANDLERS FOR MOBILE TOGGLES ---
//   const handleItemClick = (item, index) => {
//     if (item.children) {
//       toggleSubMenu(index);
//     } else {
//       navigate(item.path);
//       setIsMobileOpen(false); // Close responsive container view drawer on selection
//     }
//   };

//   return (
//     <>
//       {/* Mobile Sticky Navbar Header Trigger */}
//       <div
//         className="d-md-none"
//         style={{
//           width: '100%',
//           backgroundColor: '#ffffff',
//           borderBottom: '1px solid #e5e7eb',
//           padding: '12px 20px',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           position: 'sticky',
//           top: 0,
//           zIndex: 999,
//         }}
//       >
//         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//           <img src={A1} alt="Logo" style={{ width: '35px', height: '35px', borderRadius: '50%', objectFit: 'cover' }} />
//           <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#111827' }}>eMedha</span>
//         </div>
//         <button
//           onClick={() => setIsMobileOpen(!isMobileOpen)}
//           style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#111827', fontSize: '20px' }}
//         >
//           <i className={`fas ${isMobileOpen ? 'fa-times' : 'fa-bars'}`}></i>
//         </button>
//       </div>

//       {/* Main Container Sidebar Element Wrap */}
//       <div
//         style={{
//           display: 'flex',
//           flexDirection: 'column',
//           height: '100vh',
//           backgroundColor: '#ffffff',
//           borderRight: '1px solid #e5e7eb',
//           width: '260px',
//           boxSizing: 'border-box',
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           bottom: 0,
//           zIndex: 1000,
//           transition: 'transform 0.3s ease',
//           transform: window.innerWidth < 768 ? (isMobileOpen ? 'translateX(0)' : 'translateX(-100%)') : 'none',
//         }}
//         className={`sidebar-responsive-container ${isMobileOpen ? 'd-flex' : 'd-none d-md-flex'}`}
//       >
//         {/* Logo Section */}
//         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid #e5e7eb', }}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//             <img
//               src={A1}
//               alt="eMedha Chatbot Services logo"
//               style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }}
//             />
//             <div>
//               <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: '14px', fontWeight: 'bold', color: '#111827', lineHeight: 1, margin: 0, }}>eMedha</p>
//               <p style={{ fontSize: '10px', color: '#6b7280', marginTop: '2px', lineHeight: 1, margin: 0, }}>Chatbot Services</p>
//             </div>
//           </div>
//         </div>

//         {/* Dynamic Navigation Links Structure */}
//         <nav
//           style={{
//             flex: 1,
//             overflowY: 'auto',
//             padding: '12px',
//             display: 'flex',
//             flexDirection: 'column',
//             gap: '2px',
//           }}
//         >
//           {filteredMenuItems.map((item, index) => {
//             const isOpen = openMenu === index;
//             const isItemHovered = hoveredItem === index;

//             let itemBg = 'transparent';
//             let itemColor = '#6b7280';

//             if (isItemHovered) {
//               itemBg = '#f3f4f6';
//               itemColor = '#111827';
//             }

//             return (
//               <div key={index} style={{ width: '100%' }}>
//                 <button
//                   onClick={() => handleItemClick(item, index)}
//                   onMouseEnter={() => setHoveredItem(index)}
//                   onMouseLeave={() => setHoveredItem(null)}
//                   style={{
//                     width: '100%',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'space-between',
//                     padding: '10px 12px',
//                     borderRadius: '8px',
//                     fontSize: '14px',
//                     fontWeight: 500,
//                     border: 'none',
//                     cursor: 'pointer',
//                     textAlign: 'left',
//                     transition: 'all 0.2s ease',
//                     backgroundColor: itemBg,
//                     color: itemColor,
//                   }}
//                 >
//                   <span style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                     <span
//                       style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         color: isItemHovered ? '#111827' : '#6b7280',
//                       }}
//                     >
//                       <i className={`fas ${item.icon}`} style={{ width: '17px', textAlign: 'center' }}></i>
//                     </span>
//                     {item.label}
//                   </span>
//                   {item.children && (
//                     <span style={{ color: '#6b7280', display: 'flex', alignItems: 'center' }}>
//                       <i className={`fas fa-chevron-${isOpen ? 'down' : 'right'}`} style={{ fontSize: '11px' }}></i>
//                     </span>
//                   )}
//                 </button>

//                 {/* Inner Nested Sub-menu Child Blocks */}
//                 {item.children && isOpen && (
//                   <div
//                     style={{
//                       marginLeft: '24px',
//                       marginTop: '2px',
//                       display: 'flex',
//                       flexDirection: 'column',
//                       gap: '2px',
//                       borderLeft: '1px solid #e5e7eb',
//                       paddingLeft: '6px',
//                     }}
//                   >
//                     {item.children.map((child, childIndex) => {
//                       const childUniqueKey = `${index}-${childIndex}`;
//                       const isChildHovered = hoveredChild === childUniqueKey;

//                       return (
//                         <Link
//                           key={childIndex}
//                           to={child.path}
//                           onClick={() => setIsMobileOpen(false)}
//                           onMouseEnter={() => setHoveredChild(childUniqueKey)}
//                           onMouseLeave={() => setHoveredChild(null)}
//                           style={{
//                             width: '100%',
//                             textAlign: 'left',
//                             padding: '8px 12px',
//                             borderRadius: '6px',
//                             fontSize: '13px',
//                             fontWeight: 500,
//                             textDecoration: 'none',
//                             transition: 'all 0.2s ease',
//                             backgroundColor: isChildHovered ? '#f3f4f6' : 'transparent',
//                             color: isChildHovered ? '#111827' : '#6b7280',
//                             display: 'block',
//                           }}
//                         >
//                           {child.label}
//                         </Link>
//                       );
//                     })}
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </nav>

//         {/* User Account Admin Module & Custom Pop-up Panel */}
//         <div
//           ref={profileRef}
//           style={{
//             padding: '16px 12px',
//             borderTop: '1px solid #e5e7eb',
//             position: 'relative',
//           }}
//         >
//           {/* Pop-up Dialog System */}
//           {profileOpen && (
//             <div
//               style={{
//                 position: 'absolute',
//                 bottom: '100%',
//                 left: '12px',
//                 right: '12px',
//                 marginBottom: '8px',
//                 backgroundColor: '#ffffff',
//                 borderRadius: '12px',
//                 border: '1px solid #e5e7eb',
//                 boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
//                 overflow: 'hidden',
//                 zIndex: 1010,
//               }}
//             >
//               {[
//                 { icon: 'fa-user-circle', label: 'My Profile', action: () => navigate('/profile') },
//                 { icon: 'fa-phone', label: 'WhatsApp Numbers' },
//                 { icon: 'fa-bug', label: 'Report Bug', action: () => navigate('/reportbug') },
//               ].map((subItem) => (
//                 <button
//                   key={subItem.label}
//                   onClick={() => {
//                     if (subItem.action) subItem.action();
//                     setProfileOpen(false);
//                     setIsMobileOpen(false);
//                   }}
//                   onMouseEnter={() => setHoveredDropdownItem(subItem.label)}
//                   onMouseLeave={() => setHoveredDropdownItem(null)}
//                   style={{
//                     width: '100%',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '10px',
//                     padding: '10px 16px',
//                     fontSize: '13px',
//                     fontWeight: 500,
//                     border: 'none',
//                     textAlign: 'left',
//                     cursor: 'pointer',
//                     color: '#111827',
//                     backgroundColor: hoveredDropdownItem === subItem.label ? '#f3f4f6' : 'transparent',
//                     transition: 'background-color 0.2s ease',
//                   }}
//                 >
//                   <span style={{ color: '#6b7280', width: '15px', display: 'inline-block' }}>
//                     <i className={`fas ${subItem.icon}`}></i>
//                   </span>
//                   {subItem.label}
//                 </button>
//               ))}
//               <div style={{ height: '1px', backgroundColor: '#e5e7eb', margin: '0 12px' }} />
//               <button
//                 onMouseEnter={() => setHoveredDropdownItem('logout')}
//                 onMouseLeave={() => setHoveredDropdownItem(null)}
//                 onClick={() => {
//                   sessionStorage.clear();
//                   navigate('/');
//                 }}
//                 style={{
//                   width: '100%',
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '10px',
//                   padding: '10px 16px',
//                   fontSize: '13px',
//                   fontWeight: 500,
//                   border: 'none',
//                   textAlign: 'left',
//                   cursor: 'pointer',
//                   color: '#ef4444',
//                   backgroundColor: hoveredDropdownItem === 'logout' ? '#fef2f2' : 'transparent',
//                   transition: 'background-color 0.2s ease',
//                 }}
//               >
//                 <span style={{ width: '15px', display: 'inline-block' }}><i className="fas fa-sign-out-alt"></i></span>
//                 Log Out
//               </button>
//             </div>
//           )}

//           {/* Trigger Container Item */}
//           <button
//             onClick={() => setProfileOpen(!profileOpen)}
//             onMouseEnter={() => setHoveredProfile(true)}
//             onMouseLeave={() => setHoveredProfile(false)}
//             style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', border: 'none', cursor: 'pointer', backgroundColor: hoveredProfile ? '#f3f4f6' : 'transparent', transition: 'background-color 0.2s ease', }}
//           >
//             {userImage ? (
//               <img src={userImage} alt="Profile" style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
//             ) : (
//               <div style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: 'rgba(59, 130, 246, 0.1)', color: '#3b82f6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold', flexShrink: 0, }}>
//                 {userName.substring(0, 2).toUpperCase()}
//               </div>
//             )}
//             <div style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
//               <p style={{ fontSize: '13px', fontWeight: 600, color: '#111827', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>
//                 {userName}
//               </p>
//               <p style={{ fontSize: '10px', color: '#6b7280', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>
//                 {loggedInEmail || 'System User'}
//               </p>
//             </div>
//             <span style={{ color: '#6b7280', flexShrink: 0 }}>
//               <i className={`fas fa-chevron-${profileOpen ? 'up' : 'down'}`} style={{ fontSize: '12px' }}></i>
//             </span>
//           </button>
//         </div>
//       </div>

//       {/* Screen background shadow click-away masking cover for responsive devices */}
//       {isMobileOpen && (
//         <div
//           className="d-md-none"
//           onClick={() => setIsMobileOpen(false)}
//           style={{
//             position: 'fixed',
//             top: 0,
//             bottom: 0,
//             left: 0,
//             right: 0,
//             backgroundColor: 'rgba(0, 0, 0, 0.4)',
//             zIndex: 998,
//           }}
//         />
//       )}

//       {/* Content wrapper padding offset correction utility style for web view layouts */}
//       <style>{`
//         @media (min-width: 768px) {
//           body { padding-left: 260px; }
//         }
//       `}</style>
//     </>
//   );
// };

// export default Sidebar;


// import React, { useEffect, useState, useRef } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import A1 from '../Login/Chatbot.jpeg';

// const Sidebar = () => {
//   // --- KEEPING EXACT FUNCTIONALITIES AND STATES ---
//   const [permissions, setPermissions] = useState([]);
//   const [openMenu, setOpenMenu] = useState(null);
//   const [userName, setUserName] = useState('User Name');
//   const [userImage, setUserImage] = useState(null);
//   const [userRole, setUserRole] = useState(null);
//   const [showAppointment, setShowAppointment] = useState(false);
//   const [showTemplates, setShowTemplates] = useState(true);

//   const navigate = useNavigate();

//   // --- NEW UI STATES FOR HOVER & POPUP ---
//   const [profileOpen, setProfileOpen] = useState(false);
//   const [isMobileOpen, setIsMobileOpen] = useState(false);
//   const [hoveredItem, setHoveredItem] = useState(null);
//   const [hoveredChild, setHoveredChild] = useState(null);
//   const [hoveredProfile, setHoveredProfile] = useState(false);
//   const [hoveredDropdownItem, setHoveredDropdownItem] = useState(null);

//   const profileRef = useRef(null);

//   useEffect(() => {
//     const stored = sessionStorage.getItem("user");
//     if (stored) {
//       const u = JSON.parse(stored);
//       setUserName(u.name || "User");
//       setUserImage(u.image || null);
//       setUserRole(u.role || null);

//       // 🔍 FIX 1: Safely parse permissions whenever they are present, regardless of role string
//       if (u.permissions) {
//         try {
//           const perms = typeof u.permissions === "string" ? JSON.parse(u.permissions) : u.permissions;
//           if (Array.isArray(perms)) {
//             setPermissions(perms.map(p => p.toLowerCase()));
//           }
//         } catch (err) {
//           console.error("Invalid permissions format", err);
//           setPermissions([]);
//         }
//       }

//       if (u.email === "vckumar555@gmail.com") {
//         setShowAppointment(true);
//       }
//     }

//     // Dropdown close listener
//     function handleClick(e) {
//       if (profileRef.current && !profileRef.current.contains(e.target)) {
//         setProfileOpen(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClick);
//     return () => document.removeEventListener("mousedown", handleClick);
//   }, []);

//   const sessionUser = JSON.parse(sessionStorage.getItem("user"));
//   const loggedInUserId = sessionUser?.id;
//   const loggedInEmail = sessionUser?.email;

//   const isSuperAdmin = loggedInEmail === "emedhatechnologies@gmail.com";

//   const menuItems = [
//     { path: '/dashboard', icon: 'fa-tachometer-alt', label: 'Dashboard' },
//     {
//       path: '/singlecontacts', icon: 'fa-address-book', label: 'Manage Contacts',
//       children: [
//         { path: '/add-group', label: 'Add Groups' },
//         { path: '/singlecontacts', label: 'Add contact' },
//         { path: '/Add-new', label: 'Contact List' },
//       ]
//     },
//     { path: '/message_analytics/SendMessage', icon: 'fa-arrow-right', label: 'Send Message' },
//     {
//       path: '/message-templates',
//       icon: 'fa-envelope',
//       label: 'Message Templates',
//       children: [
//         ...(showTemplates ? [{ path: '/message-templates', label: 'Templates' }] : []),
//         ...(showAppointment ? [
//           { path: '/appointment', label: 'PP Appointment' },
//           { path: '/message-templates/us-visa-appointment', label: 'US Visa Appointment' },
//           { path: '/message-templates/labour-license', label: 'Labour License' },
//           { path: '/message-templates/trade-license', label: 'Trade License' },
//           { path: '/message-templates/birthday-greetings', label: 'Birthday Greetings' },
//           { path: '/message-templates/festival-greetings', label: 'Festival Greetings' },
//         ] : []),
//       ]
//     },
//     { path: '/message_analytics', icon: 'fa-envelope', label: 'Message Analytics' },
//     {
//       path: '/', icon: 'fa-table', label: 'Table Config',
//       children: [
//         { path: '/table-create', label: 'Table create' },
//         { path: '/usertables-list', label: 'User tables list' },
//       ]
//     },
//     {
//       path: '/', icon: 'fa-clipboard', label: 'Bot Config',
//       children: [
//         { path: '/template-Form', label: 'Template Mapping' },
//         { path: '/template-list', label: 'Template Mapping List' },
//       ]
//     },
//     {
//       path: '/', icon: 'fa-list', label: 'Column Mapping',
//       children: [
//         { path: '/column-mapping', label: 'Column Mapping' },
//         { path: '/language', label: 'Language' },
//       ]
//     },
//     {
//       path: '/', icon: 'fa-user-plus', label: 'UserCreation',
//       children: [
//         { path: '/userCreate', label: 'Create a User' },
//         { path: '/UserManagement', label: 'User Management' },
//       ]
//     },
//     {
//       path: '/', icon: 'fa-users', label: 'Groups',
//       children: [
//         { path: '/createGroup', label: 'CreateGroup' },
//         { path: '/groupMessage', label: 'Group Message' },
//         { path: '/groupsInvite', label: 'Group Invite' },
//         { path: '/getGroups', label: 'GroupInfo' },
//       ]
//     }
//   ];

//   const toggleSubMenu = (index) => {
//     setOpenMenu(openMenu === index ? null : index);
//   };

//   // 🔍 FIX 2: Evaluate permissions rules evenly across non-super-admin sessions
//   let filteredMenuItems = isSuperAdmin
//     ? menuItems
//     : menuItems
//         .map(item => {
//           // Dashboard is globally allowed
//           if (item.label === "Dashboard") return item;

//           // If item has child submenus, filter them against permission keys
//           if (item.children) {
//             const allowedChildren = item.children.filter(child =>
//               permissions.includes(child.label.toLowerCase())
//             );

//             // If sub-links are allowed or the parent heading itself matches permissions array
//             if (allowedChildren.length > 0 || permissions.includes(item.label.toLowerCase())) {
//               return { ...item, children: allowedChildren };
//             }
//             return null;
//           }

//           // Single standalone nav link permissions match check
//           if (permissions.includes(item.label.toLowerCase())) {
//             return item;
//           }

//           return null;
//         })
//         .filter(Boolean);

//   // Apply strict layout locks for UserCreation & Groups blocks based on your exact condition
//   filteredMenuItems = filteredMenuItems.filter(item => {
//     if (item.label === "UserCreation" || item.label === "Groups") {
//       return (
//         loggedInUserId === 19 ||
//         loggedInEmail === "emedhatechnologies@gmail.com"
//       );
//     }
//     return true;
//   });

//   const handleItemClick = (item, index) => {
//     if (item.children && item.children.length > 0) {
//       toggleSubMenu(index);
//     } else {
//       navigate(item.path);
//       setIsMobileOpen(false);
//     }
//   };

//   return (
//     <>
//       {/* Mobile Sticky Navbar Header Trigger */}
//       <div
//         className="d-md-none"
//         style={{
//           width: '100%',
//           backgroundColor: '#ffffff',
//           borderBottom: '1px solid #e5e7eb',
//           padding: '12px 20px',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           position: 'sticky',
//           top: 0,
//           zIndex: 999,
//         }}
//       >
//         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//           <img src={A1} alt="Logo" style={{ width: '35px', height: '35px', borderRadius: '50%', objectFit: 'cover' }} />
//           <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#111827' }}>eMedha</span>
//         </div>
//         <button
//           onClick={() => setIsMobileOpen(!isMobileOpen)}
//           style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#111827', fontSize: '20px' }}
//         >
//           <i className={`fas ${isMobileOpen ? 'fa-times' : 'fa-bars'}`}></i>
//         </button>
//       </div>

//       {/* Main Container Sidebar Element Wrap */}
//       <div
//         style={{
//           display: 'flex',
//           flexDirection: 'column',
//           height: '100vh',
//           backgroundColor: '#ffffff',
//           borderRight: '1px solid #e5e7eb',
//           width: '260px',
//           boxSizing: 'border-box',
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           bottom: 0,
//           zIndex: 1000,
//           transition: 'transform 0.3s ease',
//           transform: window.innerWidth < 768 ? (isMobileOpen ? 'translateX(0)' : 'translateX(-100%)') : 'none',
//         }}
//         className={`sidebar-responsive-container ${isMobileOpen ? 'd-flex' : 'd-none d-md-flex'}`}
//       >
//         {/* Logo Section */}
//         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid #e5e7eb', }}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//             <img
//               src={A1}
//               alt="eMedha Chatbot Services logo"
//               style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }}
//             />
//             <div>
//               <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: '14px', fontWeight: 'bold', color: '#111827', lineHeight: 1, margin: 0, }}>eMedha</p>
//               <p style={{ fontSize: '10px', color: '#6b7280', marginTop: '2px', lineHeight: 1, margin: 0, }}>Chatbot Services</p>
//             </div>
//           </div>
//         </div>

//         {/* Dynamic Navigation Links Structure */}
//         <nav
//           style={{
//             flex: 1,
//             overflowY: 'auto',
//             padding: '12px',
//             display: 'flex',
//             flexDirection: 'column',
//             gap: '2px',
//           }}
//         >
//           {filteredMenuItems.map((item, index) => {
//             const isOpen = openMenu === index;
//             const isItemHovered = hoveredItem === index;

//             let itemBg = 'transparent';
//             let itemColor = '#6b7280';

//             if (isItemHovered) {
//               itemBg = '#f3f4f6';
//               itemColor = '#111827';
//             }

//             return (
//               <div key={index} style={{ width: '100%' }}>
//                 <button
//                   onClick={() => handleItemClick(item, index)}
//                   onMouseEnter={() => setHoveredItem(index)}
//                   onMouseLeave={() => setHoveredItem(null)}
//                   style={{
//                     width: '100%',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'space-between',
//                     padding: '10px 12px',
//                     borderRadius: '8px',
//                     fontSize: '14px',
//                     fontWeight: 500,
//                     border: 'none',
//                     cursor: 'pointer',
//                     textAlign: 'left',
//                     transition: 'all 0.2s ease',
//                     backgroundColor: itemBg,
//                     color: itemColor,
//                   }}
//                 >
//                   <span style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                     <span
//                       style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         color: isItemHovered ? '#111827' : '#6b7280',
//                       }}
//                     >
//                       <i className={`fas ${item.icon}`} style={{ width: '17px', textAlign: 'center' }}></i>
//                     </span>
//                     {item.label}
//                   </span>
//                   {item.children && item.children.length > 0 && (
//                     <span style={{ color: '#6b7280', display: 'flex', alignItems: 'center' }}>
//                       <i className={`fas fa-chevron-${isOpen ? 'down' : 'right'}`} style={{ fontSize: '11px' }}></i>
//                     </span>
//                   )}
//                 </button>

//                 {/* Inner Nested Sub-menu Child Blocks */}
//                 {item.children && isOpen && (
//                   <div
//                     style={{
//                       marginLeft: '24px',
//                       marginTop: '2px',
//                       display: 'flex',
//                       flexDirection: 'column',
//                       gap: '2px',
//                       borderLeft: '1px solid #e5e7eb',
//                       paddingLeft: '6px',
//                     }}
//                   >
//                     {item.children.map((child, childIndex) => {
//                       const childUniqueKey = `${index}-${childIndex}`;
//                       const isChildHovered = hoveredChild === childUniqueKey;

//                       return (
//                         <Link
//                           key={childIndex}
//                           to={child.path}
//                           onClick={() => setIsMobileOpen(false)}
//                           onMouseEnter={() => setHoveredChild(childUniqueKey)}
//                           onMouseLeave={() => setHoveredChild(null)}
//                           style={{
//                             width: '100%',
//                             textAlign: 'left',
//                             padding: '8px 12px',
//                             borderRadius: '6px',
//                             fontSize: '13px',
//                             fontWeight: 500,
//                             textDecoration: 'none',
//                             transition: 'all 0.2s ease',
//                             backgroundColor: isChildHovered ? '#f3f4f6' : 'transparent',
//                             color: isChildHovered ? '#111827' : '#6b7280',
//                             display: 'block',
//                           }}
//                         >
//                           {child.label}
//                         </Link>
//                       );
//                     })}
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </nav>

//         {/* User Account Admin Module & Custom Pop-up Panel */}
//         <div
//           ref={profileRef}
//           style={{
//             padding: '16px 12px',
//             borderTop: '1px solid #e5e7eb',
//             position: 'relative',
//           }}
//         >
//           {/* Pop-up Dialog System */}
//           {profileOpen && (
//             <div
//               style={{
//                 position: 'absolute',
//                 bottom: '100%',
//                 left: '12px',
//                 right: '12px',
//                 marginBottom: '8px',
//                 backgroundColor: '#ffffff',
//                 borderRadius: '12px',
//                 border: '1px solid #e5e7eb',
//                 boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
//                 overflow: 'hidden',
//                 zIndex: 1010,
//               }}
//             >
//               {[
//                 { icon: 'fa-user-circle', label: 'My Profile', action: () => navigate('/profile') },
//                 { icon: 'fa-phone', label: 'WhatsApp Numbers' },
//                 { icon: 'fa-bug', label: 'Report Bug', action: () => navigate('/reportbug') },
//               ].map((subItem) => (
//                 <button
//                   key={subItem.label}
//                   onClick={() => {
//                     if (subItem.action) subItem.action();
//                     setProfileOpen(false);
//                     setIsMobileOpen(false);
//                   }}
//                   onMouseEnter={() => setHoveredDropdownItem(subItem.label)}
//                   onMouseLeave={() => setHoveredDropdownItem(null)}
//                   style={{
//                     width: '100%',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '10px',
//                     padding: '10px 16px',
//                     fontSize: '13px',
//                     fontWeight: 500,
//                     border: 'none',
//                     textAlign: 'left',
//                     cursor: 'pointer',
//                     color: '#111827',
//                     backgroundColor: hoveredDropdownItem === subItem.label ? '#f3f4f6' : 'transparent',
//                     transition: 'background-color 0.2s ease',
//                   }}
//                 >
//                   <span style={{ color: '#6b7280', width: '15px', display: 'inline-block' }}>
//                     <i className={`fas ${subItem.icon}`}></i>
//                   </span>
//                   {subItem.label}
//                 </button>
//               ))}
//               <div style={{ height: '1px', backgroundColor: '#e5e7eb', margin: '0 12px' }} />
//               <button
//                 onMouseEnter={() => setHoveredDropdownItem('logout')}
//                 onMouseLeave={() => setHoveredDropdownItem(null)}
//                 onClick={() => {
//                   sessionStorage.clear();
//                   navigate('/');
//                 }}
//                 style={{
//                   width: '100%',
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '10px',
//                   padding: '10px 16px',
//                   fontSize: '13px',
//                   fontWeight: 500,
//                   border: 'none',
//                   textAlign: 'left',
//                   cursor: 'pointer',
//                   color: '#ef4444',
//                   backgroundColor: hoveredDropdownItem === 'logout' ? '#fef2f2' : 'transparent',
//                   transition: 'background-color 0.2s ease',
//                 }}
//               >
//                 <span style={{ width: '15px', display: 'inline-block' }}><i className="fas fa-sign-out-alt"></i></span>
//                 Log Out
//               </button>
//             </div>
//           )}

//           {/* Trigger Container Item */}
//           <button
//             onClick={() => setProfileOpen(!profileOpen)}
//             onMouseEnter={() => setHoveredProfile(true)}
//             onMouseLeave={() => setHoveredProfile(false)}
//             style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', border: 'none', cursor: 'pointer', backgroundColor: hoveredProfile ? '#f3f4f6' : 'transparent', transition: 'background-color 0.2s ease', }}
//           >
//             {userImage ? (
//               <img src={userImage} alt="Profile" style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
//             ) : (
//               <div style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: 'rgba(59, 130, 246, 0.1)', color: '#3b82f6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold', flexShrink: 0, }}>
//                 {userName.substring(0, 2).toUpperCase()}
//               </div>
//             )}
//             <div style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
//               <p style={{ fontSize: '13px', fontWeight: 600, color: '#111827', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>
//                 {userName}
//               </p>
//               <p style={{ fontSize: '10px', color: '#6b7280', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>
//                 {loggedInEmail || 'System User'}
//               </p>
//             </div>
//             <span style={{ color: '#6b7280', flexShrink: 0 }}>
//               <i className={`fas fa-chevron-${profileOpen ? 'up' : 'down'}`} style={{ fontSize: '12px' }}></i>
//             </span>
//           </button>
//         </div>
//       </div>

//       {/* Screen background shadow click-away masking cover for responsive devices */}
//       {isMobileOpen && (
//         <div
//           className="d-md-none"
//           onClick={() => setIsMobileOpen(false)}
//           style={{
//             position: 'fixed',
//             top: 0,
//             bottom: 0,
//             left: 0,
//             right: 0,
//             backgroundColor: 'rgba(0, 0, 0, 0.4)',
//             zIndex: 998,
//           }}
//         />
//       )}

//       {/* Content wrapper padding offset correction utility style for web view layouts */}
//       <style>{`
//         @media (min-width: 768px) {
//           body { padding-left: 260px; }
//         }
//       `}</style>
//     </>
//   );
// };

// export default Sidebar;


// import React, { useEffect, useState, useRef } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import A1 from '../Login/Chatbot.jpeg';

// const Sidebar = () => {
//   const [permissions, setPermissions] = useState([]);
//   const [openMenu, setOpenMenu] = useState(null);
//   const [userName, setUserName] = useState('User Name');
//   const [userImage, setUserImage] = useState(null);
//   const [userRole, setUserRole] = useState(null);
//   const [showAppointment, setShowAppointment] = useState(false);
//   const [showTemplates, setShowTemplates] = useState(true);

//   const navigate = useNavigate();

//   const [profileOpen, setProfileOpen] = useState(false);
//   const [isMobileOpen, setIsMobileOpen] = useState(false);
//   const [hoveredItem, setHoveredItem] = useState(null);
//   const [hoveredChild, setHoveredChild] = useState(null);
//   const [hoveredProfile, setHoveredProfile] = useState(false);
//   const [hoveredDropdownItem, setHoveredDropdownItem] = useState(null);

//   const profileRef = useRef(null);

//   useEffect(() => {
//     const stored = sessionStorage.getItem("user");
//     if (stored) {
//       const u = JSON.parse(stored);
//       setUserName(u.name || "User");
//       setUserImage(u.image || null);
//       setUserRole(u.role || null);

//       // Parse array tokens strictly from permissions text string setup data format
//       if (u.permissions) {
//         try {
//           const perms = typeof u.permissions === "string" ? JSON.parse(u.permissions) : u.permissions;
//           if (Array.isArray(perms)) {
//             setPermissions(perms.map(p => p.toLowerCase()));
//           }
//         } catch (err) {
//           console.error("Invalid permissions format", err);
//           setPermissions([]);
//         }
//       }

//       if (u.email === "vckumar555@gmail.com") {
//         setShowAppointment(true);
//       }
//     }

//     function handleClick(e) {
//       if (profileRef.current && !profileRef.current.contains(e.target)) {
//         setProfileOpen(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClick);
//     return () => document.removeEventListener("mousedown", handleClick);
//   }, []);

//   const sessionUser = JSON.parse(sessionStorage.getItem("user"));
//   const loggedInUserId = sessionUser?.id;
//   const loggedInEmail = sessionUser?.email;

//   const menuItems = [
//     { path: '/dashboard', icon: 'fa-tachometer-alt', label: 'Dashboard' },
//     {
//       path: '/singlecontacts', icon: 'fa-address-book', label: 'Manage Contacts',
//       children: [
//         { path: '/add-group', label: 'Add Groups' },
//         { path: '/singlecontacts', label: 'Add contact' },
//         { path: '/Add-new', label: 'Contact List' },
//       ]
//     },
//     { path: '/message_analytics/SendMessage', icon: 'fa-arrow-right', label: 'Send Message' },
//     {
//       path: '/message-templates',
//       icon: 'fa-envelope',
//       label: 'Message Templates',
//       children: [
//         ...(showTemplates ? [{ path: '/message-templates', label: 'Templates' }] : []),
//         ...(showAppointment ? [
//           { path: '/appointment', label: 'PP Appointment' },
//           { path: '/message-templates/us-visa-appointment', label: 'US Visa Appointment' },
//           { path: '/message-templates/labour-license', label: 'Labour License' },
//           { path: '/message-templates/trade-license', label: 'Trade License' },
//           { path: '/message-templates/birthday-greetings', label: 'Birthday Greetings' },
//           { path: '/message-templates/festival-greetings', label: 'Festival Greetings' },
//         ] : []),
//       ]
//     },
//     { path: '/message_analytics', icon: 'fa-envelope', label: 'Message Analytics' },
//     {
//       path: '/', icon: 'fa-table', label: 'Table Config',
//       children: [
//         { path: '/table-create', label: 'Table create' },
//         { path: '/usertables-list', label: 'User tables list' },
//       ]
//     },
//     {
//       path: '/', icon: 'fa-clipboard', label: 'Bot Config',
//       children: [
//         { path: '/template-Form', label: 'Template Mapping' },
//         { path: '/template-list', label: 'Template Mapping List' },
//       ]
//     },
//     {
//       path: '/', icon: 'fa-list', label: 'Column Mapping',
//       children: [
//         { path: '/column-mapping', label: 'Column Mapping' },
//         { path: '/language', label: 'Language' },
//       ]
//     },
//     {
//       path: '/', icon: 'fa-user-plus', label: 'UserCreation',
//       children: [
//         { path: '/userCreate', label: 'Create a User' },
//         { path: '/UserManagement', label: 'User Management' },
//       ]
//     },
//     {
//       path: '/', icon: 'fa-users', label: 'Groups',
//       children: [
//         { path: '/createGroup', label: 'CreateGroup' },
//         { path: '/groupMessage', label: 'Group Message' },
//         { path: '/groupsInvite', label: 'Group Invite' },
//         { path: '/getGroups', label: 'GroupInfo' },
//       ]
//     }
//   ];

//   const toggleSubMenu = (index) => {
//     setOpenMenu(openMenu === index ? null : index);
//   };

//   // Filter based on granular items inside state permission keys array
//   const filteredMenuItems = menuItems
//     .map(item => {
//       if (item.label === "Dashboard") return item;

//       if (item.children) {
//         const allowedChildren = item.children.filter(child =>
//           permissions.includes(child.label.toLowerCase())
//         );

//         if (item.label === "Message Templates") {
//           return { ...item, children: allowedChildren };
//         }

//         if (allowedChildren.length > 0) {
//           return { ...item, children: allowedChildren };
//         }
//         return null;
//       }

//       if (permissions.includes(item.label.toLowerCase())) {
//         return item;
//       }
//       return null;
//     })
//     .filter(Boolean);

//   const handleItemClick = (item, index) => {
//     if (item.children && item.children.length > 0) {
//       toggleSubMenu(index);
//     } else {
//       navigate(item.path);
//       setIsMobileOpen(false);
//     }
//   };

//   return (
//     <>
//       {/* Mobile Sticky Navbar Header Trigger */}
//       <div
//         className="d-md-none"
//         style={{
//           width: '100%',
//           backgroundColor: '#ffffff',
//           borderBottom: '1px solid #e5e7eb',
//           padding: '12px 20px',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           position: 'sticky',
//           top: 0,
//           zIndex: 999,
//         }}
//       >
//         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//           <img src={A1} alt="Logo" style={{ width: '35px', height: '35px', borderRadius: '50%', objectFit: 'cover' }} />
//           <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#111827' }}>eMedha</span>
//         </div>
//         <button
//           onClick={() => setIsMobileOpen(!isMobileOpen)}
//           style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#111827', fontSize: '20px' }}
//         >
//           <i className={`fas ${isMobileOpen ? 'fa-times' : 'fa-bars'}`}></i>
//         </button>
//       </div>

//       {/* Main Container Sidebar Element Wrap */}
//       <div
//         style={{
//           display: 'flex',
//           flexDirection: 'column',
//           height: '100vh',
//           backgroundColor: '#ffffff',
//           borderRight: '1px solid #e5e7eb',
//           width: '260px',
//           boxSizing: 'border-box',
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           bottom: 0,
//           zIndex: 1000,
//           transition: 'transform 0.3s ease',
//           transform: window.innerWidth < 768 ? (isMobileOpen ? 'translateX(0)' : 'translateX(-100%)') : 'none',
//         }}
//         className={`sidebar-responsive-container ${isMobileOpen ? 'd-flex' : 'd-none d-md-flex'}`}
//       >
//         {/* Logo Section */}
//         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid #e5e7eb', }}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//             <img
//               src={A1}
//               alt="eMedha Chatbot Services logo"
//               style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }}
//             />
//             <div>
//               <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: '14px', fontWeight: 'bold', color: '#111827', lineHeight: 1, margin: 0, }}>eMedha</p>
//               <p style={{ fontSize: '10px', color: '#6b7280', marginTop: '2px', lineHeight: 1, margin: 0, }}>Chatbot Services</p>
//             </div>
//           </div>
//         </div>

//         {/* Dynamic Navigation Links Structure */}
//         <nav
//           style={{
//             flex: 1,
//             overflowY: 'auto',
//             padding: '12px',
//             display: 'flex',
//             flexDirection: 'column',
//             gap: '2px',
//           }}
//         >
//           {filteredMenuItems.map((item, index) => {
//             const isOpen = openMenu === index;
//             const isItemHovered = hoveredItem === index;

//             let itemBg = 'transparent';
//             let itemColor = '#6b7280';

//             if (isItemHovered) {
//               itemBg = '#f3f4f6';
//               itemColor = '#111827';
//             }

//             return (
//               <div key={index} style={{ width: '100%' }}>
//                 <button
//                   onClick={() => handleItemClick(item, index)}
//                   onMouseEnter={() => setHoveredItem(index)}
//                   onMouseLeave={() => setHoveredItem(null)}
//                   style={{
//                     width: '100%',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'space-between',
//                     padding: '10px 12px',
//                     borderRadius: '8px',
//                     fontSize: '14px',
//                     fontWeight: 500,
//                     border: 'none',
//                     cursor: 'pointer',
//                     textAlign: 'left',
//                     transition: 'all 0.2s ease',
//                     backgroundColor: itemBg,
//                     color: itemColor,
//                   }}
//                 >
//                   <span style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                     <span
//                       style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         color: isItemHovered ? '#111827' : '#6b7280',
//                       }}
//                     >
//                       <i className={`fas ${item.icon}`} style={{ width: '17px', textAlign: 'center' }}></i>
//                     </span>
//                     {item.label}
//                   </span>
//                   {item.children && item.children.length > 0 && (
//                     <span style={{ color: '#6b7280', display: 'flex', alignItems: 'center' }}>
//                       <i className={`fas fa-chevron-${isOpen ? 'down' : 'right'}`} style={{ fontSize: '11px' }}></i>
//                     </span>
//                   )}
//                 </button>

//                 {/* Inner Nested Sub-menu Child Blocks */}
//                 {item.children && isOpen && (
//                   <div
//                     style={{
//                       marginLeft: '24px',
//                       marginTop: '2px',
//                       display: 'flex',
//                       flexDirection: 'column',
//                       gap: '2px',
//                       borderLeft: '1px solid #e5e7eb',
//                       paddingLeft: '6px',
//                     }}
//                   >
//                     {item.children.map((child, childIndex) => {
//                       const childUniqueKey = `${index}-${childIndex}`;
//                       const isChildHovered = hoveredChild === childUniqueKey;

//                       return (
//                         <Link
//                           key={childIndex}
//                           to={child.path}
//                           onClick={() => setIsMobileOpen(false)}
//                           onMouseEnter={() => setHoveredChild(childUniqueKey)}
//                           onMouseLeave={() => setHoveredChild(null)}
//                           style={{
//                             width: '100%',
//                             textAlign: 'left',
//                             padding: '8px 12px',
//                             borderRadius: '6px',
//                             fontSize: '13px',
//                             fontWeight: 500,
//                             textDecoration: 'none',
//                             transition: 'all 0.2s ease',
//                             backgroundColor: isChildHovered ? '#f3f4f6' : 'transparent',
//                             color: isChildHovered ? '#111827' : '#6b7280',
//                             display: 'block',
//                           }}
//                         >
//                           {child.label}
//                         </Link>
//                       );
//                     })}
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </nav>

//         {/* User Account Admin Module & Custom Pop-up Panel */}
//         <div
//           ref={profileRef}
//           style={{
//             padding: '16px 12px',
//             borderTop: '1px solid #e5e7eb',
//             position: 'relative',
//           }}
//         >
//           {profileOpen && (
//             <div
//               style={{
//                 position: 'absolute',
//                 bottom: '100%',
//                 left: '12px',
//                 right: '12px',
//                 marginBottom: '8px',
//                 backgroundColor: '#ffffff',
//                 borderRadius: '12px',
//                 border: '1px solid #e5e7eb',
//                 boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
//                 overflow: 'hidden',
//                 zIndex: 1010,
//               }}
//             >
//               {[
//                 { icon: 'fa-user-circle', label: 'My Profile', action: () => navigate('/profile') },
//                 { icon: 'fa-phone', label: 'WhatsApp Numbers' },
//                 { icon: 'fa-bug', label: 'Report Bug', action: () => navigate('/reportbug') },
//               ].map((subItem) => (
//                 <button
//                   key={subItem.label}
//                   onClick={() => {
//                     if (subItem.action) subItem.action();
//                     setProfileOpen(false);
//                     setIsMobileOpen(false);
//                   }}
//                   onMouseEnter={() => setHoveredDropdownItem(subItem.label)}
//                   onMouseLeave={() => setHoveredDropdownItem(null)}
//                   style={{
//                     width: '100%',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '10px',
//                     padding: '10px 16px',
//                     fontSize: '13px',
//                     fontWeight: 500,
//                     border: 'none',
//                     textAlign: 'left',
//                     cursor: 'pointer',
//                     color: '#111827',
//                     backgroundColor: hoveredDropdownItem === subItem.label ? '#f3f4f6' : 'transparent',
//                     transition: 'background-color 0.2s ease',
//                   }}
//                 >
//                   <span style={{ color: '#6b7280', width: '15px', display: 'inline-block' }}>
//                     <i className={`fas ${subItem.icon}`}></i>
//                   </span>
//                   {subItem.label}
//                 </button>
//               ))}
//               <div style={{ height: '1px', backgroundColor: '#e5e7eb', margin: '0 12px' }} />
//               <button
//                 onMouseEnter={() => setHoveredDropdownItem('logout')}
//                 onMouseLeave={() => setHoveredDropdownItem(null)}
//                 onClick={() => {
//                   sessionStorage.clear();
//                   navigate('/');
//                 }}
//                 style={{
//                   width: '100%',
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '10px',
//                   padding: '10px 16px',
//                   fontSize: '13px',
//                   fontWeight: 500,
//                   border: 'none',
//                   textAlign: 'left',
//                   cursor: 'pointer',
//                   color: '#ef4444',
//                   backgroundColor: hoveredDropdownItem === 'logout' ? '#fef2f2' : 'transparent',
//                   transition: 'background-color 0.2s ease',
//                 }}
//               >
//                 <span style={{ width: '15px', display: 'inline-block' }}><i className="fas fa-sign-out-alt"></i></span>
//                 Log Out
//               </button>
//             </div>
//           )}

//           <button
//             onClick={() => setProfileOpen(!profileOpen)}
//             onMouseEnter={() => setHoveredProfile(true)}
//             onMouseLeave={() => setHoveredProfile(false)}
//             style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', border: 'none', cursor: 'pointer', backgroundColor: hoveredProfile ? '#f3f4f6' : 'transparent', transition: 'background-color 0.2s ease', }}
//           >
//             {userImage ? (
//               <img src={userImage} alt="Profile" style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
//             ) : (
//               <div style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: 'rgba(59, 130, 246, 0.1)', color: '#3b82f6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold', flexShrink: 0, }}>
//                 {userName.substring(0, 2).toUpperCase()}
//               </div>
//             )}
//             <div style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
//               <p style={{ fontSize: '13px', fontWeight: 600, color: '#111827', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>
//                 {userName}
//               </p>
//               <p style={{ fontSize: '10px', color: '#6b7280', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>
//                 {loggedInEmail || 'System User'}
//               </p>
//             </div>
//             <span style={{ color: '#6b7280', flexShrink: 0 }}>
//               <i className={`fas fa-chevron-${profileOpen ? 'up' : 'down'}`} style={{ fontSize: '12px' }}></i>
//             </span>
//           </button>
//         </div>
//       </div>

//       {isMobileOpen && (
//         <div
//           className="d-md-none"
//           onClick={() => setIsMobileOpen(false)}
//           style={{
//             position: 'fixed',
//             top: 0,
//             bottom: 0,
//             left: 0,
//             right: 0,
//             backgroundColor: 'rgba(0, 0, 0, 0.4)',
//             zIndex: 998,
//           }}
//         />
//       )}

//       <style>{`
//         @media (min-width: 768px) {
//           body { padding-left: 260px; }
//         }
//       `}</style>
//     </>
//   );
// };

// export default Sidebar;


import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import A1 from '../Login/Chatbot.jpeg';

const Sidebar = () => {
  const [permissions, setPermissions] = useState([]);
  const [openMenu, setOpenMenu] = useState(null);
  const [userName, setUserName] = useState('User Name');
  const [userImage, setUserImage] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [showAppointment, setShowAppointment] = useState(false);
  const [showTemplates, setShowTemplates] = useState(true);

  const navigate = useNavigate();

  const [profileOpen, setProfileOpen] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [hoveredChild, setHoveredChild] = useState(null);
  const [hoveredProfile, setHoveredProfile] = useState(false);
  const [hoveredDropdownItem, setHoveredDropdownItem] = useState(null);

  const profileRef = useRef(null);

  useEffect(() => {
    const stored = sessionStorage.getItem("user");
    if (stored) {
      const u = JSON.parse(stored);
      setUserName(u.name || "User");
      setUserImage(u.image || null);
      setUserRole(u.role || null);

      // Parse granular access string arrays out of state tokens safely
      if (u.permissions) {
        try {
          const perms = typeof u.permissions === "string" ? JSON.parse(u.permissions) : u.permissions;
          if (Array.isArray(perms)) {
            setPermissions(perms.map(p => p.toLowerCase()));
          }
        } catch (err) {
          console.error("Invalid permissions format", err);
          setPermissions([]);
        }
      }

      if (u.email === "vckumar555@gmail.com") {
        setShowAppointment(true);
      }
    }

    function handleClick(e) {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setProfileOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const sessionUser = JSON.parse(sessionStorage.getItem("user"));
  const loggedInEmail = sessionUser?.email;

  const menuItems = [
    { path: '/dashboard', icon: 'fa-tachometer-alt', label: 'Dashboard' },
    {
      path: '/message-templates',
      icon: 'fa-envelope',
      label: 'Message Templates',
      children: [
        ...(showTemplates ? [{ path: '/message-templates', label: 'Templates' }] : []),
        ...(showAppointment ? [
          { path: '/appointment', label: 'PP Appointment' },
          { path: '/message-templates/us-visa-appointment', label: 'US Visa Appointment' },
          { path: '/message-templates/labour-license', label: 'Labour License' },
          { path: '/message-templates/trade-license', label: 'Trade License' },
          { path: '/message-templates/birthday-greetings', label: 'Birthday Greetings' },
          { path: '/message-templates/festival-greetings', label: 'Festival Greetings' },
        ] : []),
      ]
    },
    {
      path: '/', icon: 'fa-table', label: 'Table Config',
      children: [
        { path: '/table-create', label: 'Table create' },
        { path: '/usertables-list', label: 'User tables list' },
      ]
    },
    {
      path: '/singlecontacts', icon: 'fa-address-book', label: 'Manage Contacts',
      children: [
        { path: '/add-group', label: 'Add Groups' },
        { path: '/singlecontacts', label: 'Add contact' },
        { path: '/Add-new', label: 'Contact List' },
      ]
    },
    {
      path: '/', icon: 'fa-clipboard', label: 'Bot Config',
      children: [
        { path: '/template-Form', label: 'Template Mapping' },
        { path: '/template-list', label: 'Template Mapping List' },
      ]
    },
    { path: '/message_analytics/SendMessage', icon: 'fa-arrow-right', label: 'Send Message' },
    {
      path: '/', icon: 'fa-list', label: 'Column Mapping',
      children: [
        { path: '/column-mapping', label: 'Column Mapping' },
        { path: '/language', label: 'Language' },
      ]
    },
    { path: '/message_analytics', icon: 'fa-envelope', label: 'Message Analytics' },




    {
      path: '/', icon: 'fa-user-plus', label: 'UserCreation',
      children: [
        { path: '/userCreate', label: 'Create a User' },
        { path: '/UserManagement', label: 'User Management' },
      ]
    },
    {
      path: '/', icon: 'fa-users', label: 'Groups',
      children: [
        { path: '/createGroup', label: 'CreateGroup' },
        { path: '/groupMessage', label: 'Group Message' },
        { path: '/groupsInvite', label: 'Group Invite' },
        { path: '/getGroups', label: 'GroupInfo' },
      ]
    }
  ];

  const toggleSubMenu = (index) => {
    setOpenMenu(openMenu === index ? null : index);
  };

  // ─── STRICT FILTERING LOGICAL BINDING ──────────────────────────────────────
  // If user matches emedhatechnologies@gmail.com, return all items completely.
  // Otherwise, fallback to checking lowercase matching values in permissions array.
  const filteredMenuItems = loggedInEmail === "emedhatechnologies@gmail.com"
    ? menuItems
    : menuItems
      .map(item => {
        if (item.label === "Dashboard") return item;

        if (item.children) {
          const allowedChildren = item.children.filter(child =>
            permissions.includes(child.label.toLowerCase())
          );

          if (item.label === "Message Templates") {
            return { ...item, children: allowedChildren };
          }

          if (allowedChildren.length > 0) {
            return { ...item, children: allowedChildren };
          }
          return null;
        }

        if (permissions.includes(item.label.toLowerCase())) {
          return item;
        }
        return null;
      })
      .filter(Boolean);

  const handleItemClick = (item, index) => {
    if (item.children && item.children.length > 0) {
      toggleSubMenu(index);
    } else {
      navigate(item.path);
      setIsMobileOpen(false);
    }
  };

  return (
    <>
      {/* Mobile Sticky Navbar Header Trigger */}
      <div
        className="d-md-none"
        style={{
          width: '100%',
          backgroundColor: '#ffffff',
          borderBottom: '1px solid #e5e7eb',
          padding: '12px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'sticky',
          top: 0,
          zIndex: 999,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src={A1} alt="Logo" style={{ width: '35px', height: '35px', borderRadius: '50%', objectFit: 'cover' }} />
          <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#111827' }}>eMedha</span>
        </div>
        <button
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#111827', fontSize: '20px' }}
        >
          <i className={`fas ${isMobileOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>
      </div>

      {/* Main Container Sidebar Element Wrap */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          backgroundColor: '#ffffff',
          borderRight: '1px solid #e5e7eb',
          width: '260px',
          boxSizing: 'border-box',
          position: 'fixed',
          top: 0,
          left: 0,
          bottom: 0,
          zIndex: 1000,
          transition: 'transform 0.3s ease',
          transform: window.innerWidth < 768 ? (isMobileOpen ? 'translateX(0)' : 'translateX(-100%)') : 'none',
        }}
        className={`sidebar-responsive-container ${isMobileOpen ? 'd-flex' : 'd-none d-md-flex'}`}
      >
        {/* Logo Section */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid #e5e7eb', }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <img
              src={A1}
              alt="eMedha Chatbot Services logo"
              style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }}
            />
            <div>
              <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: '14px', fontWeight: 'bold', color: '#111827', lineHeight: 1, margin: 0, }}>eMedha</p>
              <p style={{ fontSize: '10px', color: '#6b7280', marginTop: '2px', lineHeight: 1, margin: 0, }}>Chatbot Services</p>
            </div>
          </div>
        </div>

        {/* Dynamic Navigation Links Structure */}
        <nav
          style={{
            flex: 1,
            overflowY: 'auto',
            padding: '12px',
            display: 'flex',
            flexDirection: 'column',
            gap: '2px',
          }}
        >
          {filteredMenuItems.map((item, index) => {
            const isOpen = openMenu === index;
            const isItemHovered = hoveredItem === index;

            let itemBg = 'transparent';
            let itemColor = '#6b7280';

            if (isItemHovered) {
              itemBg = '#f3f4f6';
              itemColor = '#111827';
            }

            return (
              <div key={index} style={{ width: '100%' }}>
                <button
                  onClick={() => handleItemClick(item, index)}
                  onMouseEnter={() => setHoveredItem(index)}
                  onMouseLeave={() => setHoveredItem(null)}
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '10px 12px',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: 500,
                    border: 'none',
                    cursor: 'pointer',
                    textAlign: 'left',
                    transition: 'all 0.2s ease',
                    backgroundColor: itemBg,
                    color: itemColor,
                  }}
                >
                  <span style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        color: isItemHovered ? '#111827' : '#6b7280',
                      }}
                    >
                      <i className={`fas ${item.icon}`} style={{ width: '17px', textAlign: 'center' }}></i>
                    </span>
                    {item.label}
                  </span>
                  {item.children && item.children.length > 0 && (
                    <span style={{ color: '#6b7280', display: 'flex', alignItems: 'center' }}>
                      <i className={`fas fa-chevron-${isOpen ? 'down' : 'right'}`} style={{ fontSize: '11px' }}></i>
                    </span>
                  )}
                </button>

                {/* Inner Nested Sub-menu Child Blocks */}
                {item.children && isOpen && (
                  <div
                    style={{
                      marginLeft: '24px',
                      marginTop: '2px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '2px',
                      borderLeft: '1px solid #e5e7eb',
                      paddingLeft: '6px',
                    }}
                  >
                    {item.children.map((child, childIndex) => {
                      const childUniqueKey = `${index}-${childIndex}`;
                      const isChildHovered = hoveredChild === childUniqueKey;

                      return (
                        <Link
                          key={childIndex}
                          to={child.path}
                          onClick={() => setIsMobileOpen(false)}
                          onMouseEnter={() => setHoveredChild(childUniqueKey)}
                          onMouseLeave={() => setHoveredChild(null)}
                          style={{
                            width: '100%',
                            textAlign: 'left',
                            padding: '8px 12px',
                            borderRadius: '6px',
                            fontSize: '13px',
                            fontWeight: 500,
                            textDecoration: 'none',
                            transition: 'all 0.2s ease',
                            backgroundColor: isChildHovered ? '#f3f4f6' : 'transparent',
                            color: isChildHovered ? '#111827' : '#6b7280',
                            display: 'block',
                          }}
                        >
                          {child.label}
                        </Link>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        {/* User Account Admin Module & Custom Pop-up Panel */}
        <div
          ref={profileRef}
          style={{
            padding: '16px 12px',
            borderTop: '1px solid #e5e7eb',
            position: 'relative',
          }}
        >
          {profileOpen && (
            <div
              style={{
                position: 'absolute',
                bottom: '100%',
                left: '12px',
                right: '12px',
                marginBottom: '8px',
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                overflow: 'hidden',
                zIndex: 1010,
              }}
            >
              {[
                { icon: 'fa-user-circle', label: 'My Profile', action: () => navigate('/profile') },
                { icon: 'fa-phone', label: 'WhatsApp Numbers' },
                { icon: 'fa-bug', label: 'Report Bug', action: () => navigate('/reportbug') },
              ].map((subItem) => (
                <button
                  key={subItem.label}
                  onClick={() => {
                    if (subItem.action) subItem.action();
                    setProfileOpen(false);
                    setIsMobileOpen(false);
                  }}
                  onMouseEnter={() => setHoveredDropdownItem(subItem.label)}
                  onMouseLeave={() => setHoveredDropdownItem(null)}
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '10px 16px',
                    fontSize: '13px',
                    fontWeight: 500,
                    border: 'none',
                    textAlign: 'left',
                    cursor: 'pointer',
                    color: '#111827',
                    backgroundColor: hoveredDropdownItem === subItem.label ? '#f3f4f6' : 'transparent',
                    transition: 'background-color 0.2s ease',
                  }}
                >
                  <span style={{ color: '#6b7280', width: '15px', display: 'inline-block' }}>
                    <i className={`fas ${subItem.icon}`}></i>
                  </span>
                  {subItem.label}
                </button>
              ))}
              <div style={{ height: '1px', backgroundColor: '#e5e7eb', margin: '0 12px' }} />
              <button
                onMouseEnter={() => setHoveredDropdownItem('logout')}
                onMouseLeave={() => setHoveredDropdownItem(null)}
                onClick={() => {
                  sessionStorage.clear();
                  navigate('/');
                }}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '10px 16px',
                  fontSize: '13px',
                  fontWeight: 500,
                  border: 'none',
                  textAlign: 'left',
                  cursor: 'pointer',
                  color: '#ef4444',
                  backgroundColor: hoveredDropdownItem === 'logout' ? '#fef2f2' : 'transparent',
                  transition: 'background-color 0.2s ease',
                }}
              >
                <span style={{ width: '15px', display: 'inline-block' }}><i className="fas fa-sign-out-alt"></i></span>
                Log Out
              </button>
            </div>
          )}

          <button
            onClick={() => setProfileOpen(!profileOpen)}
            onMouseEnter={() => setHoveredProfile(true)}
            onMouseLeave={() => setHoveredProfile(false)}
            style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', border: 'none', cursor: 'pointer', backgroundColor: hoveredProfile ? '#f3f4f6' : 'transparent', transition: 'background-color 0.2s ease', }}
          >
            {userImage ? (
              <img src={userImage} alt="Profile" style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
            ) : (
              <div style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: 'rgba(59, 130, 246, 0.1)', color: '#3b82f6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold', flexShrink: 0, }}>
                {userName.substring(0, 2).toUpperCase()}
              </div>
            )}
            <div style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
              <p style={{ fontSize: '13px', fontWeight: 600, color: '#111827', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>
                {userName}
              </p>
              <p style={{ fontSize: '10px', color: '#6b7280', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>
                {loggedInEmail || 'System User'}
              </p>
            </div>
            <span style={{ color: '#6b7280', flexShrink: 0 }}>
              <i className={`fas fa-chevron-${profileOpen ? 'up' : 'down'}`} style={{ fontSize: '12px' }}></i>
            </span>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div
          className="d-md-none"
          onClick={() => setIsMobileOpen(false)}
          style={{
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            zIndex: 998,
          }}
        />
      )}

      <style>{`
        @media (min-width: 768px) {
          body { padding-left: 260px; }
        }
      `}</style>
    </>
  );
};

export default Sidebar;